import { Controller } from "@hotwired/stimulus"
import Rails from '@rails/ujs';
import axios from "axios"

export default class extends Controller {
  static targets = ["checkbox", "targetGroupSelect"]
  static values = {
    url: String,
    deletionUrl: String
  }

  toggleAll() {
    // If any checkboxes are already selected, we want the button to uncheck all checkboxes. If none are selected, all should be.
    const shouldBeChecked = !this.checkboxTargets.some(element => element.checked)

    this.checkboxTargets.forEach(checkboxTarget => {
      checkboxTarget.checked = shouldBeChecked
    })
  }

  submit() {
    if (this.checkedVideoIds.length === 0) { return }

    this.showLoadingIndicator()

    axios.post(this.urlValue, {
      video_group_id: this.targetGroupId,
      video_ids: this.checkedVideoIds
    })
    .then(_response => window.location.reload())
    .catch(_error => window.location.reload())
  }

  delete(event) {
    const performDeletion = Rails.confirm(event.currentTarget.dataset.confirm)
    if (!performDeletion) { return }

    axios.post(this.deletionUrlValue, {
      video_ids: this.checkedVideoIds
    })
    .then(_response => window.location.reload())
    .catch(_error => window.location.reload())
  }

  showLoadingIndicator() { document.querySelector('#videos').classList.add('is--loading') }

  get targetGroupId() {
    return this.targetGroupSelectTarget.options[this.targetGroupSelectTarget.selectedIndex].value
  }

  get checkedVideoIds() {
    let checkedVideoIds = []

    this.checkboxTargets.forEach(checkboxTarget => {
      if (!checkboxTarget.checked) { return }
      checkedVideoIds.push(checkboxTarget.value)
    })

    return checkedVideoIds
  }
}
